import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover, ProgressBar } from 'react-bootstrap';
import { analyticsTrack } from '../../../analyticsUtils';
import './ProfileCompletion.scss';
var redirectToProfile = function redirectToProfile(userPath, location) {
  analyticsTrack('Clicked on Profile Completion Card button', {
    location: location
  });
  window.location.href = userPath;
};
function attentionPopover(sectionsNeedingAttention, onSectionClick) {
  return /*#__PURE__*/React.createElement(Popover, {
    id: "profile-completion-attention-popover"
  }, /*#__PURE__*/React.createElement("div", null, "These sections still have unanswered questions:"), /*#__PURE__*/React.createElement("ul", null, sectionsNeedingAttention.map(function (section) {
    return /*#__PURE__*/React.createElement("li", {
      key: section.question_category_id
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "section-link",
      onClick: function onClick() {
        return onSectionClick(section.question_category_id);
      }
    }, section.question_category_name));
  })), /*#__PURE__*/React.createElement("div", null, "Reaching 100% is not required to submit proposals."));
}
function ProfileCompletion(_ref) {
  var header = _ref.header,
    subtext = _ref.subtext,
    percentage = _ref.percentage,
    userPath = _ref.userPath,
    location = _ref.location,
    banner = _ref.banner,
    small = _ref.small,
    sectionsNeedingAttention = _ref.sectionsNeedingAttention,
    onSectionClick = _ref.onSectionClick;
  if (percentage < 100) {
    if (small) {
      return /*#__PURE__*/React.createElement("div", {
        className: "profile-completion-small body-text-3 demibold"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React.createElement("div", null, header), subtext && /*#__PURE__*/React.createElement("div", {
        className: "normal-weight"
      }, subtext)), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-row-left-align"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bar"
      }, /*#__PURE__*/React.createElement(ProgressBar, {
        now: percentage
      })), /*#__PURE__*/React.createElement("div", {
        className: "percent"
      }, percentage, "%"), sectionsNeedingAttention.length > 0 && /*#__PURE__*/React.createElement(OverlayTrigger, {
        trigger: "click",
        rootClose: true,
        placement: "top",
        overlay: attentionPopover(sectionsNeedingAttention, onSectionClick)
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "profile-completion-attention-trigger",
        "aria-label": "Show profile sections needing attention"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-info-circle",
        "aria-hidden": "true"
      }))))));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "profile-completion-card ".concat(banner ? 'banner' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "cta"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "bold mb-8"
    }, "Strengthen your profile!"), /*#__PURE__*/React.createElement("div", {
      className: "body-text-2"
    }, header), userPath && banner && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "btn btn-quaternary bigger-button profile-completion-link mt-4",
      onClick: function onClick() {
        return redirectToProfile(userPath, location);
      }
    }, "Complete Profile")), /*#__PURE__*/React.createElement("div", {
      className: "progress-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "progress progress-circle",
      "data-percentage": percentage
    }, /*#__PURE__*/React.createElement("span", {
      className: "progress-left"
    }, /*#__PURE__*/React.createElement("span", {
      className: "progress-bar"
    })), /*#__PURE__*/React.createElement("span", {
      className: "progress-right"
    }, /*#__PURE__*/React.createElement("span", {
      className: "progress-bar"
    })), /*#__PURE__*/React.createElement("div", {
      className: "progress-value mx-auto"
    }, /*#__PURE__*/React.createElement("h1", null, percentage, "%"))), /*#__PURE__*/React.createElement("div", {
      className: "body-text-3 demibold mt-12"
    }, "Profile Completion")), userPath && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "btn btn-quaternary bigger-button full-width full-width-profile-completion-link",
      onClick: function onClick() {
        return redirectToProfile(userPath, location);
      }
    }, "Complete Profile"));
  }
  return null;
}
ProfileCompletion.propTypes = {
  header: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  percentage: PropTypes.number.isRequired,
  userPath: PropTypes.string,
  location: PropTypes.string,
  banner: PropTypes.bool,
  small: PropTypes.bool,
  sectionsNeedingAttention: PropTypes.arrayOf(PropTypes.shape({})),
  onSectionClick: PropTypes.func
};
ProfileCompletion.defaultProps = {
  userPath: null,
  location: '',
  banner: false,
  small: false,
  subtext: null,
  sectionsNeedingAttention: [],
  onSectionClick: function onSectionClick() {}
};
export default ProfileCompletion;